import React from 'react'
import { components } from 'cng-web-lib'

import FormProperties from './PingShipmentEvent_EventId_FormProperties'
import PingShipmentEventApiUrls from 'src/apiUrls/ping/PingShipmentEventApiUrls'

const { form: { CngViewForm } } = components

function ViewForm({ history, showNotification, id }) {

	return (

		//* Start JSX ----------------------------------------------------------
		<CngViewForm
			fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
			history={history}
			showNotification={showNotification}
			bodySection={
				<FormProperties.Fields
					disabled={true}
					showNotification={showNotification}
					id={id}
				/>
			}
			formikProps={FormProperties.formikProps}
			toClientDataFormat={FormProperties.toClientDataFormat}
			toServerDataFormat={FormProperties.toServerDataFormat}
			fetch={{
				url: PingShipmentEventApiUrls.GET,
				id: id
			}}
		/>
		//* End JSX ------------------------------------------------------------
	)

}

export default ViewForm
